import type * as SentryNode from '@sentry/node';
import { getFeatureFlags } from '../feature-flags';

const { sentry: sentryEnabled = false, sentryContentsquare = false } = getFeatureFlags();

export interface Sentry {
  captureException: typeof SentryNode.captureException;
  captureMessage: typeof SentryNode.captureMessage;
  getCurrentScope: typeof SentryNode.getCurrentScope;
  setupExpressErrorHandler?: typeof SentryNode.setupExpressErrorHandler;
}

// eslint-disable-next-line import/no-mutable-exports
let sentry: Sentry | null = null;

if (sentryEnabled) {
  if (__SERVER__) {
    // eslint-disable-next-line global-require, @typescript-eslint/no-require-imports
    const { initServer } = require('./server');

    sentry = initServer();
  } else {
    // eslint-disable-next-line global-require, @typescript-eslint/no-require-imports
    const { initClient } = require('./client');

    sentry = initClient({ sentryContentsquare });
  }
}

export { sentry };
